import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from 'src/environments/environment';
import { Reservation } from '../classes/reservation';

@Injectable({
  providedIn: 'root'
})
export class ReservationService {

  constructor(private httpClient: HttpClient) { }

  public CreateReservation(reservation: Reservation): Observable<any>
  {
    return this.httpClient.post(`${environment.apiUrl}/api/reservations`, reservation) as Observable<any>;
  }

  public GetReservationTimes(date: string): Observable<any>
  {
    return this.httpClient.get(`${environment.apiUrl}/api/reservations/GetReservationTimes/${date}`) as Observable<any>;
  }

  public GetAllReservationTimes(date: string): Observable<any>
  {
    return this.httpClient.get(`${environment.apiUrl}/api/reservations/GetAllReservationTimes/${date}`) as Observable<any>;
  }
}
